import * as React from 'react';
import { AnswerContentWrapper, AnswersWrapper, AnswerWrapper, ContentWrapper, HeadersWrapper, NameWrapper, Question, QuestionWrapper, ShenizCanvasingWrapper, TeamWrapper, TitleWrapper } from './ShenizCanvasingStyles';
import { language } from './ShenizCanvasingLanguage';
const json = require('./json.json');

export type Props = {};

export const ShenizCanvasingLayout = (props: Props) => {
	const render = () => {
		const returnValue = (
			<ShenizCanvasingWrapper>
				<ContentWrapper>{generateQuestions(json.questions)}</ContentWrapper>
			</ShenizCanvasingWrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};

export const generateQuestions = (questions) => {
	console.log('questions is', questions);
	const returnValue = questions.map((question) => {
		const innerReturnValue = (
			<QuestionWrapper>
				<Question>{question.question}</Question>
				<AnswersWrapper>{generateAnswers(question.responses)}</AnswersWrapper>
			</QuestionWrapper>
		);
		return innerReturnValue;
	});
	return returnValue;
};

export const generateAnswers = (answers) => {
	const returnValue = answers.map((answer) => {
		const innerReturnValue = (
			<AnswerWrapper>
				<HeadersWrapper>
					<NameWrapper>{answer.name}</NameWrapper>
					<TitleWrapper>{answer.title}</TitleWrapper>
					<TitleWrapper>{answer.datetime}</TitleWrapper>
					<TeamWrapper>{answer.team}</TeamWrapper>
				</HeadersWrapper>
				<AnswerContentWrapper>{answer.answer}</AnswerContentWrapper>
			</AnswerWrapper>
		);
		return innerReturnValue;
	});
	return returnValue;
};
